export * from './completed-successfully-profile.component';
